import { lazy } from "react";

const CallCenterIntakePage = lazy(() => import("./pages/CallCenterIntakePage"));

export const callCenterIntakeRoutes = [
  { path: "/call-center-intake", element: <CallCenterIntakePage /> },
];
